/**
 * @name lectern
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTNoNGEyIDIgMCAwMDEuOTAxLTEuMzhsMS4wNTctNC4zMzNBMSAxIDAgMDAyMSA2SDNhMSAxIDAgMDAtLjk1OCAxLjI4N0wzLjEgMTEuNjIxQTIgMiAwIDAwNS4wMDEgMTNoNCIgLz4KICA8cGF0aCBkPSJNMTUgMjJWMTFhMSAxIDAgMDAtMS0xaC00YTEgMSAwIDAwLTEgMXYxMSIgLz4KICA8cGF0aCBkPSJNMTggMjJINiIgLz4KICA8cGF0aCBkPSJNMTggNlYzYTEgMSAwIDAwLTEtMWgtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/lectern
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Lectern: string = `
<svg
  class="lucide lucide-lectern"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M15 13h4a2 2 0 001.901-1.38l1.057-4.333A1 1 0 0021 6H3a1 1 0 00-.958 1.287L3.1 11.621A2 2 0 005.001 13h4" />
  <path d="M15 22V11a1 1 0 00-1-1h-4a1 1 0 00-1 1v11" />
  <path d="M18 22H6" />
  <path d="M18 6V3a1 1 0 00-1-1h-3" />
</svg>
`;

export default Lectern;
